import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Button, InputLabel } from "@mui/material";
import InputField from "../../../../../../Authentication/components/InputField";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  textAlign: "left",
  height: "auto",
  //   overflowY: "scroll",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  //   backgroundColor:"none",
  padding: "10px 50px",
  borderRadius: "10px",
};

export default function ApplyToAllModal({variants, setApplyToAllData, sku, productType}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [price, setPrice] = React.useState("")
  const [weight, setWeight] = React.useState("")

  const modifiedVariants = variants?.map((variant) =>{
    const normalizeObj = {
        ...variant,
        original_price:price || 0,
        original_weight:weight || 0,
        sku: sku ? sku : "Not set",
        product_type:productType ? productType : variant.product_type
    }
    return normalizeObj
  })

  return (
    <>
      {/* <img src={product.img} alt="product"  /> */}
      <Button
        variant="white"
        sx={{ width: "auto", height: "45px", }}
        onClick={handleOpen}
      >
        Apply to all
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="hide_scrollbar">
            <h4 style={{ marginBottom: "30px", textAlign: "center" }}>
              Apply price and weight to all variants
            </h4>
            <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
              Product cost
            </InputLabel>
            <InputField
              onChange={(e) => {
                setPrice(e.target.value);
              }}
              placeholder="Enter product cost"
              type="number"
              size="small"
            />
            <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
              Weight(Gr.)
            </InputLabel>
            <InputField
              onChange={(e) => {
                setWeight(e.target.value);
              }}

              placeholder="Enter product weight"
              type="number"
              size="small"
            />
           

            <Button
              variant="deepblue"
            onClick={() => {
                setApplyToAllData(modifiedVariants)
            handleClose()
            }}
            
            >
              Apply to all
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
